<script>
import { mapState } from "pinia";
import { useAppStore } from "@/app-store/app";

export default {
  name: "navbar-logo",
  computed: {
    ...mapState(useAppStore, ["layoutConfig"]),
  },
};
</script>

<template>
  <router-link to="/">
    <img
      v-if="layoutConfig && layoutConfig.navbar && layoutConfig.navbar.logo"
      :src="layoutConfig.navbar.logo"
      class="h-[54px]"
    />
  </router-link>
</template>

<style scoped></style>
